function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverviewIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 233.34 232.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "overview-icon5-arrows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M116.3,232.93c-27.99-.03-55.04-10.12-76.2-28.44l-3.1-2.68v15.93h-3.66v-21.81h22.18v3.66h-15.84l3.91,3.3c20.27,17.12,45.93,26.53,72.46,26.56,16.28-.02,32.36-3.64,47.07-10.62l.86-.41,1.65,3.3-.91.42c-15.17,7.07-31.7,10.75-48.43,10.78",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M116.3,231.96c-27.76-.03-54.58-10.03-75.56-28.2l-4.71-4.07v17.08h-1.71v-19.87h20.24v1.71h-17.53l5.95,5.02c20.44,17.27,46.33,26.76,73.09,26.79,16.43-.01,32.65-3.67,47.49-10.71l.78,1.56c-15.04,7.02-31.43,10.66-48.03,10.68",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M177.81,36.97v-3.67h15.52l-3.98-3.31C168.85,12.94,143.01,3.62,116.34,3.62c-16.04,0-31.89,3.46-46.49,10.11l-.86.39-1.66-3.31.92-.42C109.8-8.46,158.52-1.27,192.86,28.76l3.11,2.72v-15.96h3.66v21.44h-21.81Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M178.79,35.99v-1.71h17.24l-6.04-5.03C169.3,12.05,143.24,2.65,116.34,2.65c-16.18,0-32.18,3.48-46.9,10.19l-.78-1.57C109.85-7.41,158.17-.29,192.22,29.5l4.72,4.13v-17.13h1.71v19.49h-19.87Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M0,117.39h3.66v3.75l-3.66.19v-3.94Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M.97,118.37h1.71v1.85l-1.71.09v-1.94Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M9.15,161.91l-.36-.91,3.2-1.24,1.41,3.35-3.23,1.43-1.03-2.63Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M10.06,161.56l1.4-.55c.11.26.56,1.33.67,1.6l-1.42.63c-.1-.25-.54-1.41-.65-1.68",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M1,132.01l3.71-.37.5,3.15-3.69.74-.52-3.52Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M2.11,132.88l1.78-.17c.07.44.14.88.21,1.32l-1.77.35c-.07-.49-.15-.99-.22-1.5",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M33.71,55.49v-14.53l-4.5-4h-14.02v-3.66h22.19v22.18h-3.67Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M34.69,54.51v-13.99l-5.1-4.53h-13.42v-1.71h20.24v20.24h-1.71Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M.41,106.05l.08-.96c.06-.7.13-1.38.21-2.01l.12-.99,3.67.55-.12.94c-.08.64-.15,1.25-.2,1.85l-.09.98-3.68-.37Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M1.46,105.18c.06-.69.13-1.36.21-1.97l1.74.26c-.08.66-.15,1.28-.2,1.88l-1.75-.17Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M7.13,76.6l.3-.89c.19-.57.38-1.13.59-1.69l.34-.93,3.35,1.31-.28.88c-.17.54-.35,1.08-.52,1.64l-.31.98-3.47-1.28Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M8.35,76.01c.18-.55.38-1.11.58-1.66l1.57.61c-.17.54-.35,1.09-.53,1.65l-1.62-.6Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M2.67,91.11l.86-3.7,3.72.93-.23.94c-.07.31-.62,2.57-.62,2.57l-3.73-.75Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M3.85,90.35c.07-.29.34-1.47.41-1.75l1.82.45c-.09.38-.36,1.52-.4,1.67l-1.83-.37Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M4.17,146.85l3.42-.9.26.93c.15.57.31,1.14.49,1.73l.28.92-3.31,1.04-1.14-3.73Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M5.4,147.53l1.51-.4c.16.57.32,1.15.5,1.76l-1.45.46c-.1-.32-.56-1.82-.56-1.82",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M13.23,62.82l.46-.88c.26-.48.54-1.01.85-1.56l.49-.86,3.22,1.89-1.67,3.08-3.34-1.67Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M14.56,62.39c.25-.48.53-1,.83-1.53l1.55.91c-.11.2-.64,1.18-.77,1.42l-1.61-.8Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M20.76,49.8l2.25-3.1,2.88,2.16-.49.76-1.44,2.24-3.2-2.07Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M22.16,49.54l1.07-1.47,1.36,1.02c-.18.27-.8,1.26-.91,1.43l-1.51-.98Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M219.94,69.78l3.22-1.43,1.38,3.54-3.19,1.24-1.41-3.35Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M221.21,70.28l1.42-.63c.1.25.53,1.38.65,1.68l-1.4.54c-.11-.26-.55-1.33-.67-1.6",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M207.44,184.04l.49-.76,1.44-2.24,3.2,2.07-2.25,3.1-2.88-2.16Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M208.75,183.8c.18-.27.8-1.26.91-1.43l1.52.98-1.07,1.47-1.36-1.02Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M229.68,115.87v-3.38l3.66-.18v3.57h-3.66Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M230.65,114.9v-1.48l1.71-.09v1.57h-1.71Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M196.34,199.59v-21.81h3.66v14.16l4.5,3.99h13.29v3.66h-21.45Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M197.31,198.62v-19.87h1.71v13.62l5.1,4.53h12.68v1.71h-19.49Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M228.07,97.83l3.73-.56.54,3.61-3.72.37-.55-3.42Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M229.19,98.65l1.8-.27c.08.54.16,1.08.24,1.64l-1.79.18c-.08-.51-.17-1.02-.25-1.55",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M225.49,86.02c-.16-.57-.31-1.14-.49-1.73l-.28-.92,3.31-1.04,1.14,3.72-3.42.9-.25-.93Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M226.43,85.76c-.16-.57-.32-1.16-.5-1.75l1.45-.46.56,1.82-1.51.4Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M228.82,130.62l.12-.95c.08-.6.15-1.21.21-1.85l.09-.98,3.68.37-.08.96c-.06.7-.14,1.38-.21,2.01l-.12.99-3.7-.55Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M229.91,129.79c.08-.61.15-1.23.22-1.88l1.75.18c-.06.69-.13,1.36-.21,1.97l-1.76-.26Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M215.24,171.94l.47-.83c.26-.46.51-.93.75-1.4l.44-.87,3.17,1.59-1.88,3.25-2.94-1.73Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M216.55,171.58c.27-.48.52-.96.77-1.44l1.38.69c-.12.2-.74,1.27-.87,1.5l-1.27-.75Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M221.6,158.58l1.07-3.22,3.54,1.3-.3.9c-.17.53-.35,1.05-.54,1.56l-.36.98-3.41-1.52Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M222.8,158.05l.48-1.43,1.71.63c-.17.52-.35,1.03-.53,1.54l-1.66-.74Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M226.08,144.58l.2-.92c.11-.5.22-1.03.32-1.6l.18-.98,3.52.7-.86,3.68-3.36-.88Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M227.23,143.88c.11-.52.22-1.06.33-1.64l1.56.31c-.07.29-.33,1.44-.4,1.72l-1.49-.39Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "overview-icon5-appliance"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M69.3,182.67c-.71,0-1.29-.58-1.29-1.29v-7.57h-.92c-3.16,0-5.72-2.56-5.72-5.72V61.77c.02-5.6,4.55-10.14,10.15-10.15h88.6c5.6.02,10.14,4.55,10.15,10.15v106.32c0,3.16-2.56,5.72-5.72,5.72h-.92v7.57c0,.71-.58,1.29-1.29,1.29h-93.03ZM161.04,173.81h-90.45v6.28h90.45v-6.28ZM63.94,168.09c0,1.73,1.41,3.14,3.14,3.14h97.46c1.73,0,3.14-1.41,3.14-3.14v-87.31H63.95v87.31ZM167.68,78.19v-16.43c0-4.18-3.39-7.56-7.57-7.57h-88.6c-4.18,0-7.56,3.39-7.57,7.57v16.43h103.74Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M69.3,182.32c-.52,0-.94-.42-.94-.94v-7.92h-1.27c-2.97,0-5.37-2.41-5.37-5.37V61.77c.02-5.41,4.39-9.78,9.8-9.8h88.6c5.41.02,9.78,4.39,9.8,9.8v106.32c0,2.97-2.41,5.37-5.37,5.37h-1.27v7.92c0,.52-.42.94-.94.94h-93.03ZM70.24,180.44h91.15v-6.98h-91.15v6.98ZM63.6,168.09c0,1.93,1.56,3.49,3.49,3.49h97.46c1.93,0,3.49-1.56,3.49-3.49v-87.66H63.6v87.66ZM71.52,53.85c-4.37,0-7.91,3.55-7.92,7.92v16.77h104.44v-16.78c0-4.37-3.55-7.91-7.92-7.92h-88.6Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M71.52,71.57c-.52,0-.94-.42-.94-.94v-8.86c0-.52.42-.94.94-.94h26.58c.52,0,.94.42.94.94v8.86c0,.52-.42.94-.94.94h-26.58ZM72.46,69.68h24.7v-6.98h-24.7v6.98Z",
    style: {
      fill: "#e4a05d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M111.39,71.92c-3.16,0-5.72-2.56-5.72-5.72s2.56-5.72,5.72-5.72,5.72,2.56,5.72,5.72h0c0,3.16-2.56,5.72-5.72,5.72M111.39,63.06c-1.73,0-3.14,1.41-3.14,3.14s1.41,3.14,3.14,3.14c1.73,0,3.14-1.41,3.14-3.14,0-1.73-1.41-3.14-3.14-3.14",
    style: {
      fill: "#e4a05d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M129.11,71.92c-3.16,0-5.72-2.56-5.72-5.72s2.56-5.72,5.72-5.72,5.72,2.56,5.72,5.72h0c0,3.16-2.56,5.72-5.72,5.72M129.11,63.06c-1.73,0-3.14,1.41-3.14,3.14s1.41,3.14,3.14,3.14c1.73,0,3.14-1.4,3.14-3.14,0-1.73-1.41-3.14-3.14-3.14",
    style: {
      fill: "#e4a05d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M142.4,67.14c-.52,0-.94-.42-.94-.94s.42-.94.94-.94h4.43c.52,0,.94.42.94.94s-.42.94-.94.94h-4.43Z",
    style: {
      fill: "#e4a05d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M155.69,67.14c-.52,0-.94-.42-.94-.94s.42-.94.94-.94h4.43c.52,0,.94.42.94.94s-.42.94-.94.94h-4.43Z",
    style: {
      fill: "#e4a05d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M115.82,160.52c-19.06,0-34.52-15.45-34.52-34.52s15.45-34.52,34.52-34.52,34.52,15.45,34.52,34.52h0c-.02,19.06-15.46,34.5-34.52,34.52M115.81,94.07c-17.64,0-31.93,14.3-31.93,31.93,0,17.64,14.3,31.93,31.93,31.93,17.64,0,31.93-14.3,31.93-31.93-.02-17.63-14.31-31.92-31.93-31.93",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M115.81,160.17c-18.87,0-34.17-15.3-34.17-34.17s15.3-34.17,34.17-34.17,34.17,15.3,34.17,34.17h0c-.02,18.86-15.31,34.15-34.17,34.17M115.81,93.72c-17.83,0-32.28,14.45-32.28,32.28s14.45,32.28,32.28,32.28,32.28-14.45,32.28-32.28c-.02-17.82-14.46-32.27-32.28-32.28",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M115.81,153.53c-11.07.02-21.07-6.62-25.35-16.83-.01-.03-.02-.05-.04-.07s-.04-.13-.04-.13l-.03-.06c-5.78-14.04.92-30.11,14.96-35.89,3.32-1.37,6.88-2.07,10.47-2.07h.14c15.14,0,27.41,12.27,27.41,27.41,0,2.4-.32,4.8-.94,7.12l-.03.11c-3.22,12.02-14.11,20.39-26.56,20.41h0ZM109.57,133.59c-.14,0-.29,0-.43,0-5.16.22-10.25,1.17-15.14,2.83l-1.43.49.72,1.33c6.74,12.43,22.28,17.05,34.72,10.31,4.65-2.52,8.41-6.42,10.75-11.17l1.67-3.38-3.38,1.67c-3.12,1.54-6.55,2.34-10.03,2.35h-.13c-.18,0-.31,0-.45,0-3.07,0-6.1-.79-8.78-2.28-2.46-1.42-5.25-2.16-8.09-2.16M109.61,131.7c3.08,0,6.1.79,8.79,2.28,2.46,1.41,5.26,2.16,8.1,2.16.14,0,.29,0,.43,0h0c3.42,0,6.79-.82,9.82-2.39,1.06-.48,2.14-.9,3.24-1.27l.68-.23.16-.7c3.09-13.79-5.57-27.47-19.36-30.57-1.84-.41-3.71-.62-5.6-.62h-.06c-14.14-.01-25.62,11.44-25.63,25.59,0,2.71.42,5.4,1.27,7.98l.4,1.23,1.22-.42c5.21-1.79,10.65-2.81,16.15-3.03h.39",
    style: {
      fill: "#e4a05d",
      strokeWidth: 0
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon5);
export default __webpack_public_path__ + "static/media/overview-icon5.bb5118f7.svg";
export { ForwardRef as ReactComponent };